import React from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import UserForm from '../Forms/UserForm';

const AddEditUserModal = ({
	dataUser,
	initialUserData,
	isOpen,
	isEdit,
	handleToggleModal,
	onRequestClose,
	onUserCreated,
	activeTab,
	toggleTab,
}) => {
	const handleModalToggle = () => {
		if (typeof onRequestClose === 'function') {
			onRequestClose();
			return;
		}
		handleToggleModal();
	};

	return (
		<Modal
			isOpen={isOpen}
			toggle={handleModalToggle}
			size='lg'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleModalToggle}>
				{isEdit ? 'Editar' : 'Agregar'} Usuario
			</ModalHeader>

			<div className='modal-content border-0 mt-3'>
				<Nav className='nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light'>
					<NavItem>
						<NavLink
							href='#'
							className={classnames({ active: activeTab === '1' })}
							onClick={() => {
								toggleTab('1');
							}}
						>
							Información
						</NavLink>
					</NavItem>
					<NavItem>
						<NavLink
							href='#'
							className={classnames({ active: activeTab === '2' })}
							onClick={() => {
								toggleTab('2');
							}}
						>
							Permisos
						</NavLink>
					</NavItem>
				</Nav>
			</div>

			<UserForm
				dataUser={dataUser}
				initialUserData={initialUserData}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleModalToggle}
				onUserCreated={onUserCreated}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
		</Modal>
	);
};

export default AddEditUserModal;
